const ALLOWED_THEMES = new Set(['light', 'dark']);
export default class ThemePreferenceService {
  static STORAGE_KEY = 'devconnect.color-scheme';
  constructor(storage, rootElement) {
    // Хранилище и корневой HTML-элемент передаются извне, чтобы сервис не зависел от глобального window
    // и его поведение можно было проверить отдельно от браузера и компонентов Flarum.
    this.storage = storage;
    this.rootElement = rootElement;
  }
  preferred() {
    try {
      // В работу допускаются только две поддерживаемые схемы. Повреждённое или устаревшее значение
      // игнорируется, чтобы оно не превращалось в произвольный data-атрибут на корневом элементе.
      const storedTheme = this.storage?.getItem(ThemePreferenceService.STORAGE_KEY);
      return ALLOWED_THEMES.has(storedTheme) ? storedTheme : null;
    } catch {
      // Браузер может запретить localStorage в приватном режиме или из-за политики безопасности.
      // В таком случае штатная схема Flarum продолжает работать без падения всей шапки.
      return null;
    }
  }
  current() {
    // Высококонтрастная тёмная схема Flarum также считается тёмной: переключатель корректно
    // показывает текущее состояние даже после выбора dark-hc на странице настроек профиля.
    const activeTheme = this.rootElement?.getAttribute('data-theme') || 'light';
    return activeTheme.startsWith('dark') ? 'dark' : 'light';
  }
  apply(theme) {
    // Метод принимает только закрытый набор значений, поэтому вызывающий код не может записать
    // в DOM произвольную строку и нарушить контракт цветовых токенов темы.
    if (!ALLOWED_THEMES.has(theme)) {
      return this.current();
    }
    this.rootElement?.setAttribute('data-theme', theme);
    return theme;
  }
  remember(theme) {
    // Невалидная схема не сохраняется: это защищает ранний bootstrap-скрипт от мусорных значений.
    if (!ALLOWED_THEMES.has(theme)) {
      return false;
    }
    try {
      this.storage?.setItem(ThemePreferenceService.STORAGE_KEY, theme);
      return true;
    } catch {
      // Отказ localStorage не мешает переключить тему в текущей вкладке. Серверная настройка
      // авторизованного пользователя при этом по-прежнему сохраняется компонентом Flarum.
      return false;
    }
  }
  toggle() {
    // Следующее состояние вычисляется из фактически применённой схемы, а не из кэша компонента,
    // поэтому сервис устойчив к смене темы через настройки профиля в соседнем интерфейсе.
    const nextTheme = this.current() === 'dark' ? 'light' : 'dark';
    this.apply(nextTheme);
    this.remember(nextTheme);
    return nextTheme;
  }
}
flarum.reg.add('devconnect-theme', 'forum/services/ThemePreferenceService', ThemePreferenceService);